import { VolumeInpaintProvider } from '@components/volumeExplorer/header/services/inpaint';
import { VolumeUploadProvider } from '@components/volumeExplorer/header/uploadFile';
import { useEffect, useState } from 'react';
import { OrganizationVolumeExplorer } from './OrganizationVolumeExplorer';
import { OrganizationVolumesTable } from './OrganizationVolumesTable';

type OrganizationVolumesProps = {
  organizationId: string;
};

export const OrganizationVolumes = ({ organizationId }: OrganizationVolumesProps) => {
  const [volumeId, setVolumeId] = useState<string>(
    new URLSearchParams(window.location.search).get('volume') || '',
  );

  useEffect(() => {
    setVolumeId(new URLSearchParams(window.location.search).get('volume') || '');
  }, [organizationId]);

  if (volumeId) {
    return (
      <VolumeUploadProvider>
        <VolumeInpaintProvider volumeId={volumeId}>
          <OrganizationVolumeExplorer volumeId={volumeId} onClearVolumeId={() => setVolumeId('')} />
        </VolumeInpaintProvider>
      </VolumeUploadProvider>
    );
  }

  return <OrganizationVolumesTable organizationId={organizationId} setVolumeId={setVolumeId} />;
};
